<p-panel>

  <div class="d-flex justify-content-between align-content-center">
    <div>
      <h4 *ngIf="flag === 'edit'">Actualizar Tarea comercial</h4>
      <h4 *ngIf="flag === 'new'">Crear Tarea comercial</h4>
    </div>
    <div style="display: flex;">
      <input type="file" #adjuntarCRM (change)="fileChange($event)" style="display: none;" />
      <button #adjuntarCRM *ngIf="model?.archivo" class="btn btn-link" (click)="verArchivo()">Ver</button>
      <input type="button" class="btn btn-success" value="Adjuntar Documento" (click)="readUrl(adjuntarCRM)" />
      
      <!-- <button pButton icon="pi pi-external-link" (click)="visible = true">
        <span class="p-button-label">Adjuntar Documento</span>
      </button> -->

    </div>
  </div>

  <app-form-builder #mainForm [model]="model" [undoEnabled]="undoEnabled" [distributionColumns]="3"
    [fields]="formFields">
  </app-form-builder>

  <div class="d-flex justify-content-center">
    <div>
      <button class="btn btn-dark mx-2" (click)="goBack()">Volver</button>
    </div>
    <app-request-button (click)="submit()" [mode]="requestButtonType" [lockOnSuccess]="true" [request]="request">
    </app-request-button>
  </div>
</p-panel>

<!-- <p-dialog id="dialog" header="Adjuntar Documento" [(visible)]="visible" [style]="{ width: '50vw' }"
  (onHide)="visible = false">
  <p-fileupload name="demo[]" url="https://www.primefaces.org/cdn/api/upload.php" (onUpload)="onUpload($event)"
    [multiple]="true" accept="application/*" maxFileSize="1000000" mode="advanced">
    <ng-template #empty>
      <div>Arrastra y suelta los archivos aquí para subir.</div>
    </ng-template>
  </p-fileupload>
</p-dialog> -->